var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "end" } },
        [
          _c(
            "el-button",
            {
              staticClass: "create-button",
              attrs: { type: "primary" },
              on: { click: _vm.openCreateDialog },
            },
            [_vm._v(_vm._s(_vm.$t("Members.new")))]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
          staticClass: "content",
        },
        [
          _vm.ownerAndManagers
            ? _c(
                "el-table",
                {
                  staticClass: "group",
                  attrs: {
                    data: _vm.ownerAndManagers,
                    "cell-class-name": "el-table-cell",
                    "row-class-name": "el-table-row",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: _vm.$t("Members.name"),
                      sortable: "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("span", [_vm._v(_vm._s(props.row.name))]),
                              props.row.id == _vm.user.id
                                ? _c("span", { staticClass: "me" }, [
                                    _vm._v(_vm._s(_vm.$t("Members.itsyou"))),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3243005384
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "email",
                      label: _vm.$t("Members.email"),
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "notes",
                      label: _vm.$t("Members.note"),
                      width: "300px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { width: "100px" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "member",
                                      params: { id: props.row.id },
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "setting el-icon-setting",
                                  }),
                                  _vm._v(_vm._s(_vm.$t("Members.detail"))),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      186319575
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: _vm.$t("Members.new"), visible: _vm.isShowingDialog },
          on: {
            "update:visible": function ($event) {
              _vm.isShowingDialog = $event
            },
            closed: _vm.closedDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoading,
                  expression: "isLoading",
                },
              ],
              ref: "dialogForm",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                "label-width": "150px",
                model: _vm.dialogForm,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Members.name"), prop: "name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.dialogForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "name", $$v)
                      },
                      expression: "dialogForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Members.email"), prop: "email" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.dialogForm.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "email", $$v)
                      },
                      expression: "dialogForm.email",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.isLoading },
                  on: { click: _vm.closeDialog },
                },
                [_vm._v(_vm._s(_vm.$t("Members.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.isLoading },
                  on: { click: _vm.sendManagerRequest },
                },
                [_vm._v(_vm._s(_vm.$t("Members.create")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }